export type ContingentWindow = {
  w: number;
  h: number;
  l: number;
};

export type ContingentBoxConfigCell = {
  w: number;
  h: number;
  hl: number;
};

export type ContingentBoxConfig = {
  cell: ContingentBoxConfigCell;
  preload: number;
};

export type ContingentExpandableRow = {
  id: number;
  name: string;
  expanded: boolean;
  height: number;
  offset: number;
};

export type ContingentDataRequest = {
  from: Date;
  to: Date;
  propertyId: number;
  cell: ContingentBoxConfigCell;
}

export type ContingentRowIdentifier = {
  month: number;
  unitType: number;
  ratePlan: ContingentRatePlanView | null;
}

export class ContingentMonthView implements ContingentExpandableRow {
  height: number;
  offset = 0;
  name = "";

  constructor(
    public id: number,
    public representationDate: string,
    public expanded: boolean,
    public unitTypes: ContingentUnitTypeView[],
    c: ContingentBoxConfigCell
  ) {
    this.id = id;
    this.unitTypes = unitTypes;
    this.height = c.h + unitTypes.length * c.h;
  }

  h(
    c: ContingentBoxConfigCell,
    selectedRatePlan: number,
    showPrice: boolean,
  ) {
    return (
      48 +
      (this.expanded
        ? 48 + this.unitTypes.reduce(
            (acc, x) =>
            acc + x.h(c, selectedRatePlan, showPrice),
            0
          )
        : 0)
    );
  }
}

export class ContingentUnitTypeView implements ContingentExpandableRow {
  constructor(
    public id: number,
    public name: string,
    public expanded: boolean,
    public height: number,
    public offset: number,
    public daysData: ContingentDaysDataView[],
    public ratePlans: ContingentRatePlanView[]
  ) {
    this.id = id;
    this.name = name;
    this.daysData = daysData;
    this.ratePlans = ratePlans;
  }

  h(
    c: ContingentBoxConfigCell,
    selectedRatePlan: number,
    showPrice: boolean,
  ) {
    return c.h + (
      showPrice &&
      this.expanded && 
      this.ratePlans.length > 0 &&
      this.ratePlans.map((x) => x.id).includes(selectedRatePlan) ? c.h : 0);
  }
}

export class ContingentDaysDataView {
  constructor(
    date: string,
    occupied: number,
    available: number,
    occupancyPercentage: number,
    demandData: ContingentDemandDataView[]
  ) {
    this.date = date;
    this.occupied = occupied;
    this.available = available;
    this.occupancyPercentage = occupancyPercentage;
    this.demandData = demandData;
  }

  date = "";
  occupied = 0;
  available = 0;
  occupancyPercentage = 0;
  demandData: ContingentDemandDataView[] = [];
}

export class ContingentDemandDataView {
  constructor(
    name: string,
    statusId: number,
  ) {
    this.name = name;
    this.statusId = statusId;
  }

  name = "";
  statusId = 0;
}

export class ContingentRatePlanView {
  constructor(
    id: number,
    name: string,
    currencyCode: string,
    ratePlanData: ContingentRatePlanDataView[],
    public isOBSpecific: boolean,
  ) {
    this.id = id;
    this.name = name;
    this.currencyCode = currencyCode;
    this.ratePlanData = ratePlanData;
  }

  id = 0;
  name = "";
  currencyCode = "";
  ratePlanData: ContingentRatePlanDataView[] = [];
}

export class ContingentRatePlanDataView {
  constructor(
    date: string,
    initializedOnly: boolean,
    price: number,
    basePriceDifference: number,
  ) {
    this.date = date;
    this.initializedOnly = initializedOnly;
    this.basePriceDifference = basePriceDifference;
    this.price = price;
  }

  date = "";
  initializedOnly = true;
  basePriceDifference = 0;
  price = 0;
}
